'use client'
import React from 'react'
import Marquee from 'react-fast-marquee'
import { PrismicNextImage } from '@prismicio/next'

type DataObject = Record<string, any>
type ItemObject = Record<string, any>

const DemoMarquee = ({ data }: { data: DataObject }) => {
  return (
    <section className="relative z-10 w-full py-16">
      <div className="container">
        <div className="rounded-lg bg-primary-ink-100 py-8">
          <p className="mb-8 text-center text-white">{data.join_text}</p>
          <Marquee>
            <div className="flex">
              {data.company_icons.map((item: ItemObject, index: number) => {
                const key = `i-${index}`
                return (
                  <div key={key} className="mx-10 flex max-w-[200px] items-center justify-center">
                    <PrismicNextImage
                      field={item.icon}
                      className="backface-hidden h-auto w-[140px] transform-gpu object-contain retina:origin-center retina:scale-110"
                      fallbackAlt=""
                    />
                  </div>
                )
              })}
            </div>
          </Marquee>
        </div>
      </div>
    </section>
  )
}

export default DemoMarquee
